import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { isInAppBrowser, openInExternalBrowser } from "../utils/browserDetect";

/**
 * 구글 로그인 처리 함수
 * @param {Function} onSuccess - 로그인 성공 시 콜백
 * @param {Function} onError - 로그인 실패 시 콜백
 * @param {Function} onInAppBrowser - 인앱 브라우저 감지 시 콜백
 * @returns {Promise<Object>} - 로그인 결과
 */
export const handleGoogleLogin = async (onSuccess, onError, onInAppBrowser) => {
  // 인앱 브라우저 감지
  if (isInAppBrowser()) {
    console.log("인앱 브라우저 감지됨, 외부 브라우저 안내 필요");
    
    // 인앱 브라우저 감지 시 콜백 실행
    if (typeof onInAppBrowser === 'function') {
      onInAppBrowser();
    }
    
    return { 
      success: false, 
      isInAppBrowser: true, 
      message: "인앱 브라우저에서는 구글 로그인이 제한됩니다." 
    };
  }

  try {
    const result = await signInWithPopup(auth, googleProvider);
    
    console.log("로그인 성공:", result.user.uid);
    
    // 성공 콜백 실행
    if (typeof onSuccess === 'function') {
      onSuccess(result.user);
    }
    
    return { success: true, user: result.user };
  } catch (error) {
    console.error("로그인 오류:", error);
    
    // 오류 콜백 실행
    if (typeof onError === 'function') {
      onError(error);
    }
    
    return { 
      success: false, 
      error: error, 
      message: error.code === 'auth/popup-closed-by-user' 
        ? "로그인이 취소되었습니다." 
        : "로그인 중 오류가 발생했습니다." 
    };
  }
};

/**
 * 인앱 브라우저 알림 다이얼로그를 표시하는 함수
 * 주의: 이 함수는 컴포넌트에서 직접 구현해야 합니다.
 * @param {Function} onOpenExternal - 외부 브라우저로 열기 클릭 시 콜백
 */
export const showInAppBrowserDialog = (onOpenExternal) => {
  // 이 함수는 실제로 컴포넌트에서 구현되어야 합니다.
  // 여기서는 인터페이스만 정의합니다.
  console.warn("showInAppBrowserDialog 함수는 컴포넌트에서 구현해야 합니다.");
  
  if (typeof onOpenExternal === 'function') {
    onOpenExternal();
  } else {
    // 기본 동작: 외부 브라우저로 열기
    openInExternalBrowser();
  }
}; 